module.exports = __webpack_public_path__ + "img/female_education.b4b8029f.png";